

export const notification_permissions ={
    required_permission:['view_notification','change_notification'],
    create_notification_permission:['add_notification','delete_notification','view_notification','change_notification']
}
